import { Stack, StackProps } from "@mui/material";

/**
 * Form row that stacks fields/actions on mobile and sits in a row on larger screens.
 */
const ResponsiveFormRow = ({ children, sx, ...props }: StackProps) => {
  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1}
      alignItems={{ xs: "stretch", sm: "center" }}
      sx={[
        {
          width: "100%",
          minWidth: 0,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      {children}
    </Stack>
  );
};

export default ResponsiveFormRow;
